import { combineReducers } from "redux";

import nudgePermission from "./nudgePermission";
import blockedPatients from "./blockedPatients";
import changeLocation from "./changeLocation";
import paymentHistory from "./paymentHistory";

const settings = combineReducers({
  nudgePermission: nudgePermission,
  blocked: blockedPatients,
  location: changeLocation,
  paymentHistory,
});

export default settings;
